import Icon from '../../components/Icon.vue'

Icon.register({
  'regular/arrow-alt-circle-up': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M256 504c-137 0-248-111-248-248s111-248 248-248 248 111 248 248-111 248-248 248zM256 56c-110.5 0-200 89.5-200 200s89.5 200 200 200 200-89.5 200-200-89.5-200-200-200zM276 384h-40c-6.6 0-12-5.4-12-12v-116h-67c-10.7 0-16-12.9-8.5-20.5l99-99c4.7-4.7 12.3-4.7 17 0l99 99c7.6 7.6 2.2 20.5-8.5 20.5h-67v116c0 6.6-5.4 12-12 12z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/regular/arrow-alt-circle-up.js
// module id = 1690
// module chunks = 0